//gsap 控制
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { goTo } from "./functions";
import { CR_PAGE } from "./constant";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const getIndex = (activeValue)=>{
    switch (activeValue){
        case 'about': return 0;
        case 'media': return 1;
        case 'team': return 2;
        case 'sample': return 3;
        case 'subscribe': return 4;
    }
}

// gsap 主要動畫Mo
export function gsapAniMo(scrollToValue) {
    ScrollTrigger.refresh();

    // 首頁
    const cr1Timeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-front",
            pin: true,
            pinSpacing: false,
            scrub: true,
            start: 'top top',
            end: "bottom top",
            // markers: true,
            id:'mo-front',
        }
    })
    cr1Timeline
        .set(".white-bg",{ opacity: 0})
        .set(".about-and-media",{opacity: 0})
        .addLabel("cr-front")
        // 圖片放大
        .to(".cr-man", { transformOrigin: "center 46%", scale: 15, duration: 10})
        // 白色遮罩
        .fromTo(".white-bg",{ opacity: 0 },{ opacity: 1, duration: 3 },"-=2")
        // 左右文字
        .to(".text-wrap-left", { xPercent: 200, duration: 6.2 },"-=5")
        .to(".text-wrap-right", { xPercent: -200, duration: 4 },"-=7.2")
        // 變白消失
        .to(".cr-front", { backgroundColor:"white", opacity: 0, duration: 2 })
        .to(".about-and-media",{opacity: 1, duration: 2})
        
    // about 文字
    const aboutTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-about",
            pin: ".about-and-media",
            pinSpacing: false,
            start: 'top top+=30%',
            end: 'top top',
            // markers: true,
            id: 'mo-about',
        }
    });

    const mediaTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-media",
            scrub: 1,
            start: 'top+=30% top',
            end: 'bottom bottom',
            // markers: true,
            id: 'mo-media',
        }
    })

    const teamTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-team",
            scrub: 1,
            // markers: true,
            start: 'top top',
            end: 'bottom bottom',
            id: 'team',
        }
    })


    const timelines = [aboutTimeline, mediaTimeline, teamTimeline];
    const linksMenu = gsap.utils.toArray(".menu-link");  
    let currentIndex = 0;

    const gotoSection = () => {
        const targetSt = timelines[currentIndex].scrollTrigger;
        gsap.to(window, {
            scrollTo: {
                y: ()=> targetSt.start,
                autoKill: false,
            },
            duration: 1,
        });
    };


    linksMenu.forEach((link, i) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            currentIndex = Number(i);
            gotoSection();
        });
    });


    if(CR_PAGE.includes(scrollToValue) && scrollToValue !== 'home'){
        currentIndex = getIndex(scrollToValue)
        gotoSection()
    }
}

// gsap 主要動畫
export function gsapAni(scrollToValue) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    ScrollTrigger.refresh();

    // 首頁
    const cr1Timeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".front-wrap",
            pin: true,
            scrub: true,
            start: 'top top',
            end: "bottom top",
            // markers: true,
            id:'front',
        }
    })
    cr1Timeline
        .set(".white-bg",{ opacity: 0})
        .set(".about-and-media",{opacity: 0})
        .addLabel("cr-front")
        // 圖片放大
        .to(".cr-man", { transformOrigin: "center 46%", scale: 50, duration: 2})
        // 白色遮罩
        .fromTo(".white-bg",{ opacity: 0 },{ opacity: 1, duration: 1 },"-=.5")
        // 左右文字
        .to(".text-wrap-left", { xPercent: 200, duration: 3 },"-=2")
        .to(".text-wrap-right", { xPercent: -250, duration: 3 },"-=2.2")
        // 變白消失
        .to(".cr-front", { backgroundColor:"white", opacity: 0, duration: 1 })
        .to(".about-and-media",{opacity: 1, duration: .5},"<")
        
        
    // about img 文字
    const aboutImgTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-about",
            pin: ".about-top-wrap",
            pinSpacer: false,
            scrub: 1,
            start: "top top",
            end: "bottom top",
            // markers: true,
            id: 'show-about-img',
        }
    });
    aboutImgTimeline
        .to(".about-img-wrap",{ opacity: 1 })
        .from('.about-mask-container',{ scale: 0, ease: 'back.out(2)', duration: .5 },"<")
        .from('.about-icons',{ scale: 0, ease: 'back.out(1)', duration: .5 })
        .from('.about-statue-img',{ yPercent: 30, opacity: 0, ease: 'back.out(2)', duration: 1 })
        .to(".cr-about",{ opacity: 1, duration: 3 },"+=2")
        .to('.cr-about',{ opacity: 0, duration: .5 })

    // about 文字
    const aboutTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-about",
            start: "bottom bottom",
            end: "bottom top",
            // markers: true,
            id: 'about-item',
            onToggle: (self) => {
                const active = self.isActive;
                if(active){
                    document.querySelector("#about-swiper").classList.add("pointer-events-auto")
                }else{
                    document.querySelector("#about-swiper").classList.remove("pointer-events-auto")
                }
            }
        }
    })

    // 圖片橫移
    const pinAboutImgTimeline = gsap.timeline({
        scrollTrigger:{
            trigger: ".cr-media",
            scrub: true, 
            start: "top center",
            end: "bottom top",
            // markers: true,
            id:'img-move',
        }
    })
    pinAboutImgTimeline
        .to(".cr-about", { opacity: 0, duration: .2 },"<")
        .to(".about-img-wrap",{ 
            x: -850,
            y: -50,
            scale: .8,
            duration: .2
        },"<")
        .to(".cr-media",{ opacity: 1, duration: .5 },"<")
        .to('.about-img-wrap',{ opacity: 1, duration: .5},"+=1")

    // 固定media
    const pinMediaTimeline =  gsap.timeline({
        scrollTrigger:{ 
            trigger:".cr-media",
            start: "top top",
            end: "bottom top",
            // markers: true,
            id:'media',
            onToggle: (self) => {
                const active = self.isActive;
                if(active){
                    document.querySelector("#media-swiper").classList.add("pointer-events-auto")
                }else{
                    document.querySelector("#media-swiper").classList.remove("pointer-events-auto")
                }
            }
        }
    })
    pinMediaTimeline
        .fromTo(".cr-media-text-wrap",{ opacity: 0},{ opacity: 1, duration: .5},"<")
        .to(".cr-media",{ opacity: 1 })

    // team cover
    const teamTimeline = gsap.timeline({
        scrollTrigger:{
            trigger: ".cr-team",
            start: "top bottom",
            end: "bottom top",
            pin: ".cr-media",
            // markers: true,
            id:'team-cover',
            toggleActions: "play play play reverse"
        }
    })
    teamTimeline
        .to(".cr-team",{ yPercent: -100, duration: .5, ease: "back.out(1)"},"<")
        .to(".about-and-media",{ duration: .5})

    // team item
    const itemsTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-team",
            pin: true,
            // pinSpacing: false,
            scrub: true,
            start: "top bottom",
            end: "bottom top",
            // markers: true,
            id: 'team-item',
        }
    })

    // team 錨點
    const itemsWhiteTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".team-container",
            scrub: true,
            start: "top+=20% center",
            end: "bottom top",
            // markers: true,
            id: 'team-item-white',
            onToggle: (self) => {
                const active = self.isActive;
                if(active){
                    document.querySelector(".white-dot").classList.remove("!hidden")
                }else{
                    document.querySelector(".white-dot").classList.add("!hidden")
                }
            }
        }
    })
    itemsWhiteTimeline
        .to(".team-container",{opacity: 1, duration: .5})
        .to(".about-img-wrap",{ opacity: 0 })
        .to(".about-and-media",{ opacity: 0})
        .fromTo(".white-dot",{ opacity: 0,  scale: 1},{opacity: 1, scale: 260, duration: 1},"<")
        .to(".team-container", { opacity: 0, duration: .5},"<")
        .to(".cr-team", { opacity: 0, duration: .5},"+=.5")
        .to(".white-dot", { opacity: 0, duration: 1})


    // 訂閱動畫
    const faqBackgroundTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".cr-subscribe",
            scrub: true,
            start: "top center",
            end: "top top",
            // markers: true,
            id: 'subscribe-move'
        }
    })
    faqBackgroundTimeline
        .to(".cr-media",{ opacity: 0 })
        .to(".subscribe-wrap",{ opacity: 1, duration: 1},"<")
        .fromTo(".subscribe-button",{ y:100 },{ y: 0, opacity: 1, ease: "back.out(2)" },"<")
        .from(".subscribe-link", { opacity: 0, ease: "back.out(2)" },"<")
        .from(".subscribe-input", { opacity: 0, ease: "back.out(2)" },"<")
        .from(".subscribe-title", { y: -200, opacity: 0, ease: "back.out(2)" },"<")
        .from(".subscribe-img-left",{ xPercent: -10, opacity: 0, ease: "back.out(2)"},"<")
        .from(".subscribe-img-right",{ xPercent: 10, opacity: 0, ease: "back.out(2)"},"<")

    // 立即訂閱 錨點
    const subscribeTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".subscribe-wrap",
            start: "top-=2 top",
            end: "bottom top",
            // markers: true,
            id: 'subscribe-target',
            onToggle: (self) =>{
                const active = self.isActive;
                if(active){
                    document.querySelector(".subscribe-input").classList.add("pointer-events-auto")
                    document.querySelector(".subscribe-link").classList.add("pointer-events-auto")
                }else{
                    document.querySelector(".subscribe-input").classList.remove("pointer-events-auto")
                    document.querySelector(".subscribe-link").classList.remove("pointer-events-auto")
                }
            }
        }
    })

    let scrollTimeout = null;  // 用來記錄滾動停止的計時器
    let scrollIndex = 0;
    let preScrollIndex = 0;

    let currentIndex = 0;

    // menu button 跳轉
    const btnTimelines = [aboutTimeline, pinMediaTimeline, itemsWhiteTimeline];

    const linksMenu = gsap.utils.toArray(".menu-link");  

    const gotoSection = () => {
        const targetSt = btnTimelines[currentIndex].scrollTrigger;
        gsap.to(window, {
            scrollTo: {
                y: ()=> currentIndex === 1
                ? targetSt.start + 1
                : targetSt.start,
                autoKill: false,
            },
            duration: 1,
        });
    };

    linksMenu.forEach((link, i) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            currentIndex = Number(i);
            scrollIndex = currentIndex + 1
            gotoSection();
        });
    });


    if(CR_PAGE.includes(scrollToValue) && scrollToValue !== 'home'){
        currentIndex = getIndex(scrollToValue)
        scrollIndex = currentIndex + 1
        gotoSection()
    }

    // scroll 跳轉
    const scrollTimelines = [cr1Timeline, aboutTimeline, pinMediaTimeline, itemsWhiteTimeline, subscribeTimeline];

    // 頁面移動
    const scrollToSection = () => {
        const targetSt = scrollTimelines[scrollIndex].scrollTrigger;
        gsap.to(window, {
            scrollTo: {
                y: ()=> scrollIndex === 1 || scrollIndex === 2 || scrollIndex === 4
                    ? scrollIndex === 4
                        ?   targetSt.start + 5
                        :   targetSt.start + 1
                    : targetSt.start ,
                autoKill: false,
            },
            duration: ()=> 
                // home->about 或 about->home
                ( scrollIndex === 0 || preScrollIndex === 0 && scrollIndex === 1 )
                    ?   2
                    :   1

        });
        preScrollIndex = scrollIndex
    };

    // 監聽頁面上下滾動
    const handleScroll = (e) => {
        const target = e.target
        
        if(target.id !== 'cr-home'){
            
            const aboutSwiperWrap = document.querySelector('#about-swiper')
            const mediaSwiperWrap = document.querySelector('#media-swiper')
            const teamSwiperWrap = document.querySelector('#team-swiper')

            const isScrollSwiper = 
                aboutSwiperWrap.contains(target) 
                || mediaSwiperWrap.contains(target) 
                || teamSwiperWrap.contains(target) 
                || target.classList.contains('about-item')
                || target.classList.contains('team-item')
                || target.classList.contains('media-item')
                || target.closest('.subscribe-input')
                || target.classList.contains('subscribe-button')
                || target.classList.contains('business-button')
    
            // pointer-event-auto的元件 禁止Ｙ軸滑動
            if(isScrollSwiper && e.deltaY !== 0) return e.preventDefault();

            return;
        }

        e.preventDefault();
        
        if (scrollTimeout === null) {  // 每次滾動初始時才會進入此處
            const delta = e.deltaY; // 判斷滾動方向 (正值：向下滾動，負值：向上滾動)

            if (delta >= 1) {
                // console.log('向下滾動');
                if(scrollIndex === scrollTimelines.length-1) return

                scrollIndex++;

            } else if( delta <= -1) {
                // console.log('向上滾動');
                if(scrollIndex > 0){
                    scrollIndex--
                }else{
                    scrollIndex = 0;
                }
            }
            goTo(e, CR_PAGE?.[scrollIndex])
            scrollToSection()
        }
    
        // 如果滾動超過一段時間後（如 200ms），則允許再次滾動
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            scrollTimeout = null;  // 計時器結束，允許下一次滾動
        }, 100);  // 停滯時間設定為 200 毫秒，可根據需求調整
    };
    
    // 監聽畫面滾動
    window.addEventListener('wheel', handleScroll, { passive: false });

}
